/**
 * Utility functions for API configuration
 */

/**
 * Determines if we should use mock APIs or real SOE backend
 */
export const shouldUseMockAPIs = (): boolean => {
  // Check the USE_MOCK_APIS environment variable
  // If explicitly set to 'true', use mocks
  // If set to 'false' or not set, use real APIs
  return process.env.USE_MOCK_APIS === 'true';
};

/**
 * Gets the SOE API base URL for production backend calls
 */
export const getSOEApiBaseURL = (): string => {
  const soeApiUrl = process.env.SOE_API_BASE_URL ?? process.env.SOE_API_URL;
  const soeEndpoint = process.env.SOE_DEVICE_UNLOCK_ENDPOINT ?? '/device-unlock/v1';
  
  return soeApiUrl ? `${soeApiUrl}${soeEndpoint}` : '';
};